import { cn } from "~/lib/utils";

function Spacer({ size }: { size: "4xl" | "3xl" | "2xl" | "xl" | "lg" | "md" | "sm" | "xs" }) {
  return (
    <div
      // style={{
      //   height:
      //     size === "4xl"
      //       ? "6rem"
      //       : size === "3xl"
      //         ? "4.5rem"
      //         : size === "2xl"
      //           ? "3rem"
      //           : size === "xl"
      //             ? "2rem"
      //             : size === "lg"
      //               ? "1rem"
      //               : size === "md"
      //                 ? "0.5rem"
      //                 : size === "sm"
      //                   ? "0.25rem"
      //                   : "0.125rem",
      // }}
      className={cn(
        size === "4xl" && "h-32 xl:h-44",
        size === "3xl" && "h-24 xl:h-32",
        size === "2xl" && "h-16 xl:h-24",
        size === "xl" && "h-10 xl:h-16",
        size === "lg" && "h-8 xl:h-12",
        size === "md" && "h-6 xl:h-8",
        size === "sm" && "h-3 xl:h-4",
        size === "xs" && "h-2 xl:h-2"
      )}
    />
  );
}

export { Spacer };
